import React from 'react';
import { CATEGORIES } from '../data/content';
import { scrollToBuy } from '../utils/constants';
export function Categories() {
  return <section aria-labelledby="categories-title" className="w-full bg-soft px-3 py-6 sm:px-5" data-id="element-37" data-mp="rbbq6s2t9hjd">
      <div className="mx-auto max-w-6xl" data-id="element-38" data-mp="meldmeq7t42p">
        <h2 id="categories-title" className="text-center font-head text-2xl uppercase leading-[0.98] text-navy sm:text-4xl" data-id="element-39" data-mp="heqke4iyw2eh">
          Essential learning — all in one place
        </h2>

        <div className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-3" data-id="element-40" data-mp="1f4bqylk0w1xr">
          {CATEGORIES.map(cat => {
          const Icon = cat.icon;
          return <button key={cat.title} type="button" onClick={scrollToBuy} aria-label={`Go to the purchase section — ${cat.title}`} className="flex items-start gap-2.5 rounded-xl border border-line bg-white p-3 text-left transition-colors duration-150 ease-out hover:border-navy/40" data-id="element-41" data-mp="15bmh1v44ew4j">
                <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-white ${cat.accent}`} data-id="element-42" data-mp="1t1qj3y1nuntf">
                  <Icon className="h-4 w-4" aria-hidden="true" data-id="element-43" data-mp="366bm9ezpb5n3" />
                </span>
                <span className="flex flex-col" data-id="element-44" data-mp="3b4d7o6klnh1q">
                  <span className="font-head text-base uppercase leading-tight text-navy sm:text-lg" data-id="element-45" data-mp="3b66fvqav29bu">
                    {cat.title}
                  </span>
                  <span className="mt-0.5 text-[11px] font-semibold leading-snug text-muted sm:text-[12px]" data-id="element-46" data-mp="31d8sp6uxbw6w">
                    {cat.items}
                  </span>
                </span>
              </button>;
        })}
        </div>

        <p className="mt-3 text-center font-head text-base uppercase leading-tight text-navy sm:text-xl" data-id="element-47" data-mp="2rdzyccw5cfk0">
          Everything organized inside one complete visual system.
        </p>
      </div>
    </section>;
}